/* eslint-disable
    import/no-duplicates,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
import OrgConstants from 'constants/OrgConstants'
import UserConstants from 'constants/UserConstants'
import GateConstants from 'constants/GateConstants'
import EmbedConstants from 'constants/EmbedConstants'
import { captureException } from 'utils/SentryHelpers'
import { captureResponseException } from 'utils/SentryHelpers'

const OrgQueries = Marty.createQueries({
  id: 'OrgQueries',

  createOrg(settings) {
    return new Promise((resolve, reject) => {
      const promise = this.app.sources.OrgAPI.createOrg(settings)
      return promise.then(res => {
        try {
          if (res.status === 200) {
            this.dispatch(UserConstants.USER_CREATE_DONE, settings.email, res.body.user, res.body.accessToken)
            this.dispatch(OrgConstants.ORG_CREATE_DONE, res.body.organization)
            this.dispatch(GateConstants.SET_GATE_DONE, res.body.gates)
            this.dispatch(EmbedConstants.EMBED_CREATE_DONE, res.body.embed.configuration.inboxId, res.body.embed)
            return resolve(res)
          } else if (res.status === 400) {
            this.dispatch(UserConstants.EMAIL_ALREADY_REGISTERED, settings.email)
            return reject(res)
          } else {
            this.dispatch(OrgConstants.USER_CREATE_WITH_EMAIL_FAILED, settings.email, res)
            this.app.actions.NotificationActions.pushNotification({
              content: "An error ocurred while creating your account. Please try again later.",
              variant: 'red',
              sticky: true,
            })
            return reject(res)
          }
        } catch(error) {
          captureException(error)
          this.dispatch(OrgConstants.USER_CREATE_WITH_EMAIL_FAILED, settings.email, error)
          this.app.actions.NotificationActions.pushNotification({
            content: "An error ocurred while creating your account. Please try again later.",
            variant: 'red',
            sticky: true,
          })
          return reject(error)
        }
      })
    })
  },

  fetchOrgById(orgId) {
    const promise = this.app.sources.OrgAPI.fetchOrgById(orgId)

    promise.then(res => {
      if (res.status === 200) {
        return this.dispatch(OrgConstants.ORG_FETCH_DONE, res.body)
      } else {
        captureResponseException(res)
        return this.dispatch(OrgConstants.ORG_FETCH_FAILED, res)
      }
    })

    return promise.catch(error => {
      captureException(error)
      return this.dispatch(OrgConstants.ORG_FETCH_FAILED, error)
    })
  },

  sendInvitations(emails, orgId, scopes) {
    const promise = this.app.sources.OrgAPI.sendInvitations(emails, orgId, scopes)

    promise.then(res => {
      if (res.status === 200) {
        this.dispatch(OrgConstants.INVITE_TO_ORG_DONE, emails, orgId, res.body)
        return this.app.actions.NotificationActions.pushNotification({ content: "Your invitations have been sent!" })
      } else if (res.status === 400) {
        return this.app.actions.NotificationActions.pushNotification({
          variant: "red",
          content: res.body.message
        })
      } else {
        this.app.actions.NotificationActions.pushNotification({
          variant: "red",
          content: res.body.message
        })
        return this.dispatch(OrgConstants.INVITE_TO_ORG_FAILED, res)
      }
    })

    return promise.catch(error => {
      captureException(error)
      return this.dispatch(OrgConstants.INVITE_TO_ORG_FAILED, error)
    })
  },

  shareSnippet(email, orgId) {
    const promise = this.app.sources.OrgAPI.shareEmailSnippet(email, orgId)

    promise.then(res => {
      if (res.status === 200) {
        this.dispatch(OrgConstants.SHARE_SNIPPET_DONE, email, orgId, res.body)
        return this.app.actions.NotificationActions.pushNotification({ content: "Your message has been sent!" })
      } else if (res.status === 400) {
        return this.app.actions.NotificationActions.pushNotification({
          variant: "red",
          content: res.body.message
        })
      } else {
        this.app.actions.NotificationActions.pushNotification({
          variant: "red",
          content: "We are having trouble sending your invitations right now."
        })
        return this.dispatch(OrgConstants.SHARE_SNIPPET_FAILED, res)
      }
    })

    return promise.catch(error => {
      captureException(error)
      return this.dispatch(OrgConstants.SHARE_SNIPPET_FAILED, error)
    })
  },

  resendInvitation(email, orgId) {
    const promise = this.app.sources.OrgAPI.sendInvitation(email, orgId)

    promise.then(res => {
      if (res.status === 200) {
        this.dispatch(OrgConstants.RESEND_INVITE_DONE, email, orgId, res.body)
        return this.app.actions.NotificationActions.pushNotification({
          content: `${ email } will receive another invite email shortly!`
        })
      } else {
        captureResponseException(res)
        return this.dispatch(OrgConstants.RESEND_INVITE_FAILED, res)
      }
    })

    return promise.catch(error => {
      captureException(error)
      return this.dispatch(OrgConstants.RESEND_INVITE_FAILED, error)
    })
  },

  updateOrg(orgId, update) {
    this.dispatch(OrgConstants.ORG_UPDATE_STARTING, orgId)
    const promise = this.app.sources.OrgAPI.updateOrg(orgId, update)
    promise.then(res => {
      if (res.status === 200) {
        return this.dispatch(OrgConstants.ORG_UPDATE_DONE, orgId, res.body, update)
      } else {
        captureResponseException(res)
        return this.dispatch(OrgConstants.ORG_UPDATE_FAILED, orgId, update, res)
      }
    })

    return promise.catch(error => {
      captureException(error)
      return this.dispatch(OrgConstants.ORG_UPDATE_FAILED, orgId, update, error)
    })
  },
})

export default OrgQueries



// WEBPACK FOOTER //
// ./src/scripts/queries/OrgQueries.js